import createMetadataAPITypes from '../../utils/api-metadata-types';

const actions = createMetadataAPITypes({ baseType: 'CERTIFICATIONS' });

export default {
  ...actions,
  CLEAR_CERTIFICATIONS: 'CLEAR_CERTIFICATIONS'
};
